(function () {
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var targets = document.querySelectorAll('.afolki-reveal, .afolki-root-svg');
    if (!targets.length) return;

    if (prefersReduced || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-visible', 'is-drawn'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible', 'is-drawn');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -40px 0px' });

    targets.forEach(function (el) { observer.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }
  document.addEventListener('shopify:section:load', initReveal);

  // Refresh the native Horizon cart drawer (count badge + contents) after an
  // AJAX add-to-cart performed outside their own product-form component.
  // Uses Shopify's documented Section Rendering API rather than a custom
  // event, since the theme's cart-drawer-component does not listen for one.
  // cache: 'no-store' + a timestamp bust the browser HTTP cache: without it,
  // a repeated identical GET can be served from cache and show the cart
  // state from BEFORE the add, even though the add itself succeeded.
  window.afolkiRefreshCartDrawer = function () {
    var target = document.getElementById('shopify-section-cart-drawer-section');
    if (!target) return Promise.resolve();
    return fetch('/?sections=cart-drawer-section&_=' + Date.now(), { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer-section'];
        if (html) target.outerHTML = html;
      })
      .catch(function () { /* fail silently: item is still in the real cart */ });
  };
})();
